import { Box, Container, FormControl, IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import Brands from "../components/brands";
import { getClient } from "../Providers/graphqlClient";
import cssVars from "../styles/vars.module.scss"
import SearchIcon from '@mui/icons-material/Search';
import { useState } from "react";
import { BRANDS_CATEGORIES } from "../graphql/categories/queries";
import CustomMetas from "../components/custom-metas";
import useTranslation from "../hooks/useTranslation";

const BrandsPage = (props) => {

    const brands = props.brandsData.categories.items[0].children
    const parent = props.brandsData.categories.items[0]
    const [brandsData, setBrandsData] = useState(brands)

    const filter = (value) => {
        setBrandsData(brands.filter(brand => !value || brand.name.toUpperCase().includes(value.toUpperCase())))
    }

    const { t } = useTranslation()

    return (
        <Container maxWidth="xl">
            <CustomMetas title={parent.meta_title || parent.name}
                description={parent.meta_description}
                keywords={parent.meta_keywords}
                page_type="product.item"
                image={parent.image}
                path="brands.html"
                />

            <Box mb="50px">
                <FormControl id="mainSearch" fullWidth variant="standard">
                    <OutlinedInput
                        type="search"
                        sx={{ borderRadius: cssVars.radius }}
                        placeholder={t("Search")}
                        size="small"
                        onChange={(e) => { filter(e.target.value) }}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton edge="end">
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
            <Box component="section">
                <Brands brands={brandsData} />
            </Box>
        </Container>
    );
}

export default BrandsPage;

export const getStaticProps = async ({ locale }) => {

    const client = getClient(locale)

    const { data: brandsData } = await client.query({
        query: BRANDS_CATEGORIES
    })

    return {
        props: {
            brandsData,
        },
        revalidate: 10,
    }
}

